export default __webpack_public_path__ + "static/media/workspace_bg.2b52b36e.png";